/** Copyright line under the sign-in form. */
export default function FooterAuthDefault() {
  return (
    <p className="text-center text-sm text-fg-muted lg:mb-0">
      © {new Date().getFullYear()} Atrium. All rights reserved.
    </p>
  );
}
